import caseCBC from "./CheckTests/CaseCBC";

export const checkResultAlert = (result, testInput=null, type='function') => {

  // NOTE: Add Alert JS check here
  const algorithms = [
    caseCBC
  ];
  const results = [];

  algorithms.forEach(algorithm => {
    try {
      algorithm(result, testInput, type)
    } catch (e) {
      if (typeof e === 'object') {
        results.push(...e)
      } else {
        results.push(e);
      }

    }
  })

  return results
}
